/**
 * NOTE:
 * - R6 April [amended:改定]
 */

import { t } from "i18next"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"
import { FormFieldsProp } from "../../../../molecules/FormFields/types"
import { ServiceType } from "./types"

type Params = {
  name: string
  serviceType: ServiceType
}

const LABELS = {
  [ServiceType.AFTER_SCHOOL_DAY_SERVICE]: t("Service provision hours"),
  [ServiceType.CHILD_DEVELOPMENT_SUPPORT]: t(
    "Support categories for preschoolers"
  ),
}

/**
 * Version management: Facility Status Form
 * @param {Moment} date
 * @param {Params} params
 * @return {FormFieldsProp|null}
 */
export function getSupportCategories(date: Moment, params: Params) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
      return baseline(params.name, LABELS[params.serviceType])
    default:
      return r6April(params.name, LABELS[params.serviceType])
  }
}

/**
 * --------------------------------
 * @version R6_APRIL
 * --------------------------------
 */

function r6April(name: string, label: string): FormFieldsProp {
  return {
    fieldLabel: label,
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              {
                label: t("No"),
                value: "0",
              },
              {
                label: t("I"),
                value: "1",
              },
              {
                label: t("II"),
                value: "2",
              },
              {
                label: t("III"),
                value: "3",
              },
            ],
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version BASELINE
 * --------------------------------
 */

function baseline(name: string, label: string): FormFieldsProp {
  return {
    fieldLabel: label,
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              {
                label: t("No"),
                value: "0",
              },
              {
                label: t("I"),
                value: "1",
              },
              {
                label: t("II"),
                value: "2",
              },
            ],
          },
        },
      },
    ],
  }
}
